import React from 'react';
import Cookies from 'js-cookie';
import { doc, collection, query, where, orderBy, onSnapshot, setDoc, deleteDoc } from 'firebase/firestore';
import { useNavigate, useParams } from 'react-router-dom';
import SharePanel from '../components/SharePanel';
import MsgNetLoading from '../components/MsgNetLoading';
import TopHeaderMenu from '../components/TopHeaderMenu';
import ResultadoDetailHeader from '../components/ResultadoDetailHeader';
import ResultadoDetailTiempo from '../components/ResultadoDetailTiempo';
import ResultadoDetailMenu from '../components/ResultadoDetailMenu';
import CompeticionHeaderMenu from '../components/CompeticionHeaderMenu';
import ResultadoDetailTablaPasos from '../components/ResultadoDetailTablaPasos';
import ResultadoDetailTablaPuestos from '../components/ResultadoDetailTablaPuestos';
import ResultadoDetailTablaRankings from '../components/ResultadoDetailTablaRankings';
import { calculaPrevision } from '../utils/time';
import { FirebaseContext } from '../index';

class ResultadoScreenClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      time: 0,
      evento: null,
      sectores: [],
      controlList: [],
      resultado: null,
      notificar: false,
      competicion: null,
      botonSeleccionado: 1,
      showSharePanel: false,
      rankingsResultados: [],
      favoritos: []
    };
    this.unlisten = {
      evento: null,
      control: null,
      sectores: null,
      resultado: null,
      competicion: null
    };
  }

  toogleSharePanel() {
    this.setState(state => ({
      showSharePanel: !this.state.showSharePanel
    }));
  }

  componentDidMount() {
    const { db, params } = this.props;
    const dorsal = parseInt(params.dorsal, 10);
    const competicionId = parseInt(params.competicionId, 10);

    // Cargar favoritos de cookies
    const favoritosCookie = Cookies.get('favoritos-' + competicionId);
    if (favoritosCookie) {
      try {
        const favoritos = JSON.parse(favoritosCookie);
        this.setState({ favoritos });
      } catch (e) {
        this.setState({ favoritos: [] });
      }
    } else {
      this.setState({ favoritos: [] });
    }

    // Competición
    const competicionRef = doc(db, 'competicion', competicionId.toString());
    this.unlisten.competicion = onSnapshot(competicionRef, (snapshot) => {
      let competicion = snapshot.exists() ? snapshot.data() : null;
      if (competicion) {
        competicion.id = snapshot.id;
      }
      this.setState({ competicion });
    });

    // Resultado
    const resultadoRef = doc(db, 'resultado', `${competicionId}-${dorsal}`);
    this.unlisten.resultado = onSnapshot(resultadoRef, (snapshot) => {
      let resultado = snapshot.exists() ? snapshot.data() : null;
      if (resultado) {
        resultado.id = snapshot.id;
      }
      this.setState({ resultado });
    });

    // Sectores
    const sectoresQuery = query(
      collection(db, 'sector'),
      where('competicion_id', '==', competicionId),
      orderBy('inicio', 'asc')
    );
    this.unlisten.sectores = onSnapshot(sectoresQuery, (snapshot) => {
      let sectores = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      this.setState({ sectores });
    });

    // Rankings Resultados
    const rankingsResultadosQuery = query(
      collection(db, 'ranking_resultado'),
      where('dorsal', '==', dorsal),
      where('competicion_id', '==', competicionId)
    );
    this.unlisten.rankingsResultados = onSnapshot(rankingsResultadosQuery, (snapshot) => {
      let rankingsResultados = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      this.setState({ rankingsResultados });
    });

    // Controles
    const controlesQuery = query(
      collection(db, 'control'),
      where('competicion_id', '==', competicionId),
      where('visible', '==', true),
      orderBy('distancia', 'asc')
    );
    this.unlisten.controles = onSnapshot(controlesQuery, (snapshot) => {
      let controlList = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      this.setState({ controlList });
    });

    // Actualizar para redibujar crono
    this.interval = setInterval(() => this.setState({ time: Date.now() }), 1000);
  }

  // UNSAFE_componentWillUpdate(nextProps, nextState) {
  //   const { db } = this.props;

  //   if (nextState.competicion !== this.state.competicion) {
  //     if (nextState.competicion && nextState.competicion.evento_id) {
  //       // Validar y convertir evento_id a string
  //       const eventoId = nextState.competicion.evento_id;

  //       if (eventoId) {
  //         const eventoRef = doc(db, 'evento', String(eventoId));
  //         this.unlisten.evento = onSnapshot(eventoRef, (snapshot) => {
  //           let evento = snapshot.exists() ? snapshot.data() : null;
  //           if (evento) {
  //             evento.id = snapshot.id;
  //           }
  //           this.setState({ evento });
  //         });
  //       }
  //     }
  //   }
  // }
  componentDidUpdate(prevProps, prevState) {
    const { db } = this.props;

    // Cargar evento cuando se carga la competición
    if (prevState.competicion !== this.state.competicion) {
      if (this.state.competicion && this.state.competicion.evento_id) {
        const eventoId = this.state.competicion.evento_id;

        if (eventoId) {
          const eventoRef = doc(db, 'evento', String(eventoId));
          this.unlisten.evento = onSnapshot(eventoRef, (snapshot) => {
            let evento = snapshot.exists() ? snapshot.data() : null;
            if (evento) {
              evento.id = snapshot.id;
            }
            this.setState({ evento });
          });
        }
      }
    }
  }

  componentWillUnmount() {
    if (this.unlisten.evento) {
      this.unlisten.evento();
    }
    if (this.unlisten.competicion) {
      this.unlisten.competicion();
    }
    if (this.unlisten.controles) {
      this.unlisten.controles();
    }
    if (this.unlisten.sectores) {
      this.unlisten.sectores();
    }
    if (this.unlisten.resultado) {
      this.unlisten.resultado();
    }
    if (this.unlisten.rankingsResultados) {
      this.unlisten.rankingsResultados();
    }
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  esFavorito() {
    const { params } = this.props;
    const dorsal = parseInt(params.dorsal, 10);
    return this.state.favoritos.indexOf(dorsal) >= 0;
  }

  async onClickFavorito() {
    const { db, params } = this.props;
    const competicionId = parseInt(params.competicionId, 10);
    const dorsal = parseInt(params.dorsal, 10);

    let favoritos = [...this.state.favoritos];
    let idx = favoritos.indexOf(dorsal);

    if (idx >= 0) {
      // Eliminar favorito
      favoritos.splice(idx, 1);
      if (window.FCM_TOKEN) {
        const fstKey = competicionId + '-' + dorsal + '-' + window.FCM_TOKEN;
        await deleteDoc(doc(db, 'fcm', fstKey));
      }
      if (typeof window.ga === 'function') {
        window.ga('set', 'favoritoDel', favoritos.length);
      }
    } else {
      // Añadir favorito
      favoritos.push(dorsal);
      if (window.FCM_TOKEN) {
        const fstKey = competicionId + '-' + dorsal + '-' + window.FCM_TOKEN;
        await setDoc(doc(db, 'fcm', fstKey), {
          competicion_id: competicionId,
          dorsal,
          token: window.FCM_TOKEN
        });
      }
      if (typeof window.ga === 'function') {
        window.ga('set', 'favoritoAdd', favoritos.length);
      }
    }

    this.setState({ favoritos });

    // Guardar en cookie
    Cookies.set('favoritos-' + competicionId, JSON.stringify(favoritos), {
      path: '/',
      expires: 30
    });
  }

  onClickBack() {
    this.props.navigate(-1);
  }

  onClickNotificar() {
    this.setState({
      'notificar': !this.state.notificar
    });
  }

  onSelectBoton(index) {
    this.setState({ 'botonSeleccionado': index });
  }

  esNotificar() {
    return this.state.notificar;
  }

  renderDetailTable(props) {
    switch (this.state.botonSeleccionado) {
      case 1:
        return <ResultadoDetailTablaPasos {...props} />;
      case 2:
        return <ResultadoDetailTablaPuestos {...props} />;
      case 3:
        return <ResultadoDetailTablaRankings rankingsResultados={this.state.rankingsResultados} />;
      default:
        return <div />;
    }
  }

  render() {
    const { evento, competicion, controlList, sectores, resultado } = this.state;

    if (resultado && competicion) {
      const prevision = calculaPrevision(competicion, controlList, sectores, resultado, null);

      return (
        <div>
          <TopHeaderMenu
            onClickBack={this.onClickBack.bind(this)}
            onClickShare={this.toogleSharePanel.bind(this)}
            competicion={competicion}
            selected={1}
            evento={evento}
          />
          <CompeticionHeaderMenu
            competicion={this.state.competicion}
            selected={4}
            evento={this.state.evento}
          />
          <div className="min-h-screen pt-28">
            <ResultadoDetailHeader
              resultado={resultado}
              esFavorito={this.esFavorito()}
              onClickFavorito={this.onClickFavorito.bind(this)}
              esNotificar={this.esNotificar()}
              onClickNotificar={this.onClickNotificar.bind(this)}
            />
            <ResultadoDetailTiempo
              resultado={resultado}
              competicion={competicion}
              guntime={competicion.guntime}
              fechaInicio={competicion.fecha_inicio}
              prevision={prevision}
              controles={controlList}
            />
            <ResultadoDetailMenu
              resultado={resultado}
              controlList={controlList}
              tieneRankings={competicion.ranking_numero > 0}
              onSelectBoton={this.onSelectBoton.bind(this)}
              botonSeleccionado={this.state.botonSeleccionado}
            />
            {this.renderDetailTable({
              competicion,
              resultado,
              prevision,
              sectores,
              controlList
            })}
          </div>
          {this.state.showSharePanel && (
            <SharePanel
              close={this.toogleSharePanel.bind(this)}
              url={`/competicion/${competicion.id}/dorsal/${resultado.dorsal}`}
              title={`Resultados en vivo de ${resultado.nombre} ${resultado.apellidos} en ${evento.nombre}.`}
            />
          )}
        </div>
      );
    } else {
      return <MsgNetLoading />;
    }
  }
}

// Wrapper funcional
function ResultadoScreen() {
  const navigate = useNavigate();
  const params = useParams();
  const { db } = React.useContext(FirebaseContext);

  return <ResultadoScreenClass navigate={navigate} params={params} db={db} />;
}

export default ResultadoScreen;